import { render } from "./comp.entete.vue?vue&type=template&id=33127f00"
import script from "./comp.entete.vue?vue&type=script&lang=js"
export * from "./comp.entete.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__